/**
 * @typedef {import('./lib/index.js').Options} Options
 */

export {default} from './lib/index.js'
